var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"meeting-counter"},_vm._l((_setup.timeArr),function(item){return _c('div',{key:item.label,staticClass:"meeting-counter__item"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }